// src/pages/ApplicationChampionshipSeason/shared/steps/Step1Info/SeasonFormatOption.tsx
import { FunctionComponent } from 'react';
import { Box, Radio, Text } from '@chakra-ui/react';
import { SeasonType } from '@/model';

type SeasonFormatOptionProps = {
  value: SeasonType;
  title: string;
  help: string;
  isSelected: boolean;
};

export const SeasonFormatOption: FunctionComponent<SeasonFormatOptionProps> = ({
  value,
  title,
  help,
  isSelected,
}) => (
  <Box
    borderWidth="1px"
    borderColor={isSelected ? 'brand.500' : 'gray.200'}
    bg={isSelected ? 'purple.50' : 'white'}
    borderRadius="md"
    transition="background 0.15s, border-color 0.15s"
  >
    <Radio
      value={value}
      colorScheme="brand"
      alignItems="flex-start"
      w="100%"
      px={4}
      py={3}
      m={0}
    >
      <Box ml={1}>
        <Text fontWeight="medium" color={isSelected ? 'brand.600' : 'text.main'}>
          {title}
        </Text>
        <Text fontSize="13px" color="gray.500">
          {help}
        </Text>
      </Box>
    </Radio>
  </Box>
);
